import ApplicationController from "../application_controller.js";

export default class extends ApplicationController {
  connect() {
    this.log_function("connect");

    this.element[this.identifier] = this;
    this.boundSubmitForm = this.submitForm.bind(this);

    window.addEventListener("recaptchaV2--solved", this.boundSubmitForm);
  }

  submitForm(){
    this.log_function("submitForm");

    this.element.requestSubmit();
  }

  disconnect(){
    this.log_function("disconnect");

    window.removeEventListener("recaptchaV2--solved", this.boundSubmitForm);
  }
}
